// https://lineascan.build/address/0x0D3f821e9741C8a8Bcac231162320251Db0cdf52
export const CROSS_CHAIN_CONTROLLER = '0x0D3f821e9741C8a8Bcac231162320251Db0cdf52';

// IPayloadsControllerCore https://lineascan.build/address/0x3BcE23a1363728091bc57A58a226CF2940C2e074
export const PAYLOADS_CONTROLLER = '0x3BcE23a1363728091bc57A58a226CF2940C2e074';

// https://lineascan.build/address/0x6d4F341d8Bb3Dc5ABe822Aa940F1884508C13f99
export const PC_DATA_HELPER = '0x6d4F341d8Bb3Dc5ABe822Aa940F1884508C13f99';

// https://lineascan.build/address/0xc1cd6faF6e9138b4e6C21d438f9ebF2bd6F6cA16
export const GRANULAR_GUARDIAN = '0xc1cd6faF6e9138b4e6C21d438f9ebF2bd6F6cA16';

// https://lineascan.build/address/0x056E4C4E80D1D14a637ccbD0412CDAAEc5B51F4E
export const GOVERNANCE_GUARDIAN = '0x056E4C4E80D1D14a637ccbD0412CDAAEc5B51F4E';

// https://lineascan.build/address/0x8c2d95FE7aeB57b86961F3abB296A54f0ADb7F88
export const EXECUTOR_LVL_1 = '0x8c2d95FE7aeB57b86961F3abB296A54f0ADb7F88';

export const CHAIN_ID = 59144;
